'use strict';

const {
	div, button,
	input, label, select, option
} = require('iblokz-snabbdom-helpers');

const {obj, str} = require('iblokz-data');
const urlFile = require('./url-file');
const {fieldLabel, enumLabel} = require('./label');

const remove = (list, index) => [].concat(
	list.slice(0, index),
	list.slice(index + 1)
);

const setAt = (list, index, key, value) => [].concat(
	list.slice(0, index),
	[{...list[index], [key]: value}],
	(index < list.length - 1) ? list.slice(index + 1) : []
);

const patchAt = (list, index, patch) => [].concat(
	list.slice(0, index),
	[{...list[index], ...patch}],
	(index < list.length - 1) ? list.slice(index + 1) : []
);

const coerce = (type, value) => {
	if (type === 'Number') {
		const n = Number(value);
		return Number.isNaN(n) ? 0 : n;
	}
	return value;
};

const colTrack = col => {
	if (col.type === 'Number') return 'minmax(0, 4.5rem)';
	if (col.enum instanceof Array) return 'minmax(0, 7rem)';
	if (col.key === 'url') return 'minmax(0, 2fr)';
	return 'minmax(0, 1fr)';
};

const gridStyle = columns => ({
	display: 'grid',
	gridTemplateColumns: columns.map(colTrack).concat('1.75rem').join(' '),
	gap: '6px',
	alignItems: 'center',
	width: '100%',
	boxSizing: 'border-box'
});

const urlKind = item => item._urlKind || (item.source === 'upload' || item._file ? 'file' : 'url');

const blankItem = newItem => (typeof newItem === 'function' ? newItem() : {...newItem});

const titleFromFile = file => String(file.name || '').replace(/\.[^.]+$/, '') || file.name;

const itemFromFile = (base, file, hasTitle) => Object.assign({}, base, {
	_urlKind: 'file',
	source: 'upload',
	_file: file,
	_fileName: file.name,
	url: ''
}, hasTitle ? {title: titleFromFile(file)} : {});

module.exports = ({path, columns, newItem, state, actions, i18n = {}}) => {
	const list = obj.sub(state, path) || [];
	const rowStyle = gridStyle(columns);
	const hasSource = columns.some(col => col.key === 'source');
	const hasTitle = columns.some(col => col.key === 'title');
	return div('.form-items', [].concat(
		list.length
			? [
				div('.form-items-header', {style: rowStyle}, [].concat(
					columns.map(col => div('.col', [
						label(col.label || fieldLabel(i18n, col.key))
					])),
					div('.col.col-actions', [label('×')])
				)),
				div('.form-items-list', list.map((item, k) =>
					div('.form-items-row', {style: rowStyle, attrs: {'data-index': String(k)}}, [].concat(
						columns.map(col =>
							div('.col', [
								col.enum instanceof Array
									? select('.form-control', {
										on: {
											change: ev => {
												const source = ev.target.value;
												const patch = col.key === 'source'
													? {
														source,
														_urlKind: source === 'upload' ? 'file' : 'url',
														_file: source === 'upload' ? item._file : undefined,
														_fileName: source === 'upload' ? item._fileName : undefined
													}
													: {[col.key]: source};
												actions.set(path, patchAt(list, k, patch));
											}
										}
									}, col.enum.map(val => option({
										attrs: {
											value: val,
											selected: (item[col.key] !== undefined ? item[col.key] : col.enum[0]) === val
										},
										props: {
											value: val,
											selected: (item[col.key] !== undefined ? item[col.key] : col.enum[0]) === val
										}
									}, enumLabel(i18n, col.key, val))))
									: (col.key === 'url' && hasSource)
										? urlFile({
											kind: urlKind(item),
											url: item.url || '',
											fileName: item._fileName || '',
											multiple: true,
											onKind: kind => actions.set(path, patchAt(list, k, {
												_urlKind: kind,
												source: kind === 'file' ? 'upload' : (item.source === 'upload' ? 'external' : item.source),
												_file: kind === 'file' ? item._file : undefined,
												_fileName: kind === 'file' ? item._fileName : undefined
											})),
											onUrl: v => actions.set(path, patchAt(list, k, {url: v, _urlKind: 'url'})),
											onFile: files => {
												const first = Object.assign({}, item, {
													_urlKind: 'file',
													source: 'upload',
													_file: files[0],
													_fileName: files[0].name,
													url: ''
												});
												if (hasTitle && !item.title) first.title = titleFromFile(files[0]);
												const rest = files.slice(1).map(f =>
													itemFromFile(blankItem(newItem), f, hasTitle)
												);
												actions.set(path, [].concat(
													list.slice(0, k),
													[first],
													rest,
													list.slice(k + 1)
												));
											},
											onClear: () => actions.set(path, patchAt(list, k, {
												url: '',
												_file: undefined,
												_fileName: undefined
											}))
										})
										: input('.form-control', {
											attrs: {
												type: col.type === 'Number' ? 'number' : 'text',
												step: col.type === 'Number' ? 0.01 : undefined,
												value: item[col.key] !== undefined ? item[col.key] : '',
												size: 1
											},
											on: {
												input: ev => actions.set(path, setAt(list, k, col.key, coerce(col.type, ev.target.value)))
											}
										})
							])
						),
						div('.col.col-actions', [
							button('.fa.fa-minus[type="button"]', {
								on: {click: () => actions.set(path, remove(list, k))}
							})
						])
					))
				))
			]
			: [],
		button('.form-items-add.btn[type="button"]', {
			on: {
				click: () => actions.set(path, [].concat(list, [blankItem(newItem)]))
			}
		}, (i18n.common && i18n.common.actions && i18n.common.actions.add) || 'Add')
	));
};
